import { AlertCircle, Clock, Link2Off, BarChart } from "lucide-react";
import { Reveal } from "./Reveal";

const problems = [
    {
        icon: AlertCircle,
        text: "Businesses spend money on marketing without knowing what really works.",
    },
    {
        icon: Clock,
        text: "Good leads are missed or followed up too slowly.",
    },
    {
        icon: Link2Off,
        text: "Owners often cannot connect ad spend to real sales or revenue.",
    },
    {
        icon: BarChart,
        text: "Marketing reports focus on clicks and impressions instead of commercial outcomes.",
    },
];

export const Problem = () => (
    <section className="bg-white py-24 lg:py-32" data-testid="problem-section">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <Reveal>
                <p className="text-sm font-semibold uppercase tracking-wider text-[#2563EB]">
                    The Problem
                </p>
                <h2 className="mt-3 max-w-2xl text-3xl font-bold tracking-tight text-[#0B1F44] lg:text-4xl">
                    Marketing activity is not the same as commercial growth.
                </h2>
            </Reveal>
            <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2">
                {problems.map((p, i) => (
                    <Reveal key={i} delay={i * 0.08}>
                        <div
                            data-testid={`problem-card-${i}`}
                            className="fp-card-shadow flex h-full items-start gap-4 rounded-2xl border border-gray-100 bg-[#F8FAFC] p-7 transition-shadow"
                        >
                            <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#2563EB]/10">
                                <p.icon className="h-5 w-5 text-[#2563EB]" />
                            </span>
                            <p className="text-base leading-relaxed text-[#374151]">
                                {p.text}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
